import { changeLanguage, language } from '@storytune/assets/lang/index'
import { alertError } from './ts/alert'
import { renderEntryLoadError } from './ts/entryLoadError'
import { startApplicationAfterEnvironment } from './ts/entryStartup'
import { installRuntimeEnvironment } from './ts/polyfill'
import { recordStartupMilestone } from './ts/startupReadiness'

// 产品启动前的错误提示也使用产品语言；引擎冒烟仍沿用其语言初始化流程。
if (import.meta.env.VITE_FASTIFY_BROWSER_SMOKE !== 'TRUE') changeLanguage('cn')
recordStartupMilestone('entry', 0)

function entryLoadErrorMessage(): string {
  return navigator.onLine === false ? language.preloadOfflineError : language.preloadLoadError
}

function showEntryLoadError(error: unknown): void {
  console.error('Application entry load failed:', error)
  const message = entryLoadErrorMessage()
  alertError(message)
  renderEntryLoadError({
    documentTarget: document,
    message,
    reloadLabel: language.preloadReload,
    onReload: () => window.location.reload(),
  })
}

window.addEventListener('vite:preloadError', (event) => {
  // Before the shell mounts, the entry preloader is the only recoverable error
  // surface. Once it is gone, allow the dynamic import promise to reject so the
  // owning LazyComponent can render its local retry/reload controls.
  if (!document.getElementById('preloading')) return
  event.preventDefault()
  showEntryLoadError(event)
})

const app = startApplicationAfterEnvironment(installRuntimeEnvironment, () =>
  import.meta.env.VITE_FASTIFY_BROWSER_SMOKE === 'TRUE' ? import('./appStartup') : import('./product/startup'),
).catch((error) => {
  showEntryLoadError(error)
  return null
})

export default app
